import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore } from '@/store/auth-store'
import { isJwtExpired } from '@/utils/jwt'

export function GuestRoute() {
  const { isAuthenticated, accessToken } = useAuthStore()

  const tokenValid = isAuthenticated && accessToken != null && !isJwtExpired(accessToken)

  if (tokenValid) return <Navigate to="/dashboard" replace />

  return <Outlet />
}
